import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reverse";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useMemo, useState, useCallback } from 'react';
import AntCascader from 'antd/lib/cascader';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
var Cascader = /*#__PURE__*/React.memo(props => {
  var _props$children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var onClick = useCallback(({
    keyPath
  }) => {
    if (typeof props.onChange === 'function') {
      props.onChange(_reverseInstanceProperty(keyPath).call(keyPath).join(''));
    }
    setVisible(false);
  }, [props.onChange]);
  var getMenu = useCallback((dataSource, depth) => {
    if (depth === 0) {
      return /*#__PURE__*/React.createElement(Menu, {
        className: "sk-cascader-menu",
        onClick: onClick
      }, _mapInstanceProperty(dataSource).call(dataSource, item => {
        if (item.children) {
          return /*#__PURE__*/React.createElement(Menu.SubMenu, {
            popupClassName: "sk-cascader-submenu",
            key: item.label,
            title: item.label
          }, getMenu(item.children, depth + 1));
        } else {
          return /*#__PURE__*/React.createElement(Menu.Item, {
            key: item.label
          }, item.label);
        }
      }));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, _mapInstanceProperty(dataSource).call(dataSource, item => {
        if (item.children) {
          return /*#__PURE__*/React.createElement(Menu.SubMenu, {
            popupClassName: "sk-cascader-submenu",
            key: item.label,
            title: item.label
          }, getMenu(item.children, depth + 1));
        } else {
          return /*#__PURE__*/React.createElement(Menu.Item, {
            key: item.label
          }, item.label);
        }
      }));
    }
  }, [onClick]);
  var overlay = useMemo(() => getMenu(props.options, 0), [getMenu, props.options]);
  var onVisibleChange = useCallback(() => setVisible(visible => !visible), []);
  return /*#__PURE__*/React.createElement(Dropdown, {
    trigger: ['click'],
    placement: "bottomLeft",
    overlay: overlay,
    overlayClassName: "sk-cascader",
    visible: visible,
    onVisibleChange: onVisibleChange
  }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : '');
});
Cascader.Ant = AntCascader;
export default Cascader;